import { render, staticRenderFns } from "./payment_info.vue?vue&type=template&id=2e5468fa&scoped=true&"
import script from "./payment_info.vue?vue&type=script&lang=js&"
export * from "./payment_info.vue?vue&type=script&lang=js&"
import style0 from "./payment_info.vue?vue&type=style&index=0&id=2e5468fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5468fa",
  null
  
)

export default component.exports